{
  "color": [
    "#06f3aa",
    "#3ab2fc",
    "#ff931b",
    "#fa4747",
    "#b01cff",
    "#ffd10a",
    "#a9a9a9"
  ],
  "backgroundColor": "#252b36",
  "textStyle": {},
  "title": {
    "textStyle": {
      "color": "#ffffff"
    },
    "subtextStyle": {
      "color": "#06f3aa"
    }
  },
  "line": {
    "itemStyle": {
      "borderWidth": 0
    },
    "lineStyle": {
      "width": 2
    },
    "symbolSize": 8,
    "symbol": "circle",
    "smooth": false
  },
  "radar": {
    "itemStyle": {
      "borderWidth": 0
    },
    "lineStyle": {
      "width": 2
    },
    "symbolSize": 8,
    "symbol": "circle",
    "smooth": false
  },
  "bar": {
    "itemStyle": {
      "barBorderWidth": 0,
      "barBorderColor": "#d9d9d9"
    }
  },
  "pie": {
    "itemStyle": {
      "borderWidth": 0,
      "borderColor": "#d9d9d9"
    }
  },
  "scatter": {
    "itemStyle": {
      "borderWidth": 0,
      "borderColor": "#d9d9d9"
    }
  },
  "boxplot": {
    "itemStyle": {
      "borderWidth": 0,
      "borderColor": "#d9d9d9"
    }
  },
  "parallel": {
    "itemStyle": {
      "borderWidth": 0,
      "borderColor": "#d9d9d9"
    }
  },
  "sankey": {
    "itemStyle": {
      "borderWidth": 0,
      "borderColor": "#d9d9d9"
    }
  },
  "funnel": {
    "itemStyle": {
      "borderWidth": 0,
      "borderColor": "#d9d9d9"
    }
  },
  "gauge": {
    "itemStyle": {
      "borderWidth": 0,
      "borderColor": "#d9d9d9"
    }
  },
  "candlestick": {
    "itemStyle": {
      "color": "#fa4747",
      "color0": "#06F3AA",
      "borderColor": "#fa4747",
      "borderColor0": "#06F3AA",
      "borderWidth": 2
    }
  },
  "graph": {
    "itemStyle": {
      "borderWidth": 0,
      "borderColor": "#d9d9d9"
    },
    "lineStyle": {
      "width": 1,
      "color": "#d9d9d9"
    },
    "symbolSize": 8,
    "symbol": "circle",
    "smooth": false,
    "color": [
      "#06f3aa",
      "#3ab2fc",
      "#ff931b",
      "#fa4747",
      "#b01cff",
      "#ffd10a",
      "#a9a9a9"
    ],
    "label": {
      "color": "#252b36"
    }
  },
  "map": {
    "itemStyle": {
      "areaColor": "#eee",
      "borderColor": "#444",
      "borderWidth": 0.5
    },
    "label": {
      "color": "#000"
    },
    "emphasis": {
      "itemStyle": {
        "areaColor": "#06f3aa",
        "borderColor": "#444",
        "borderWidth": 1
      },
      "label": {
        "color": "#002dff"
      }
    }
  },
  "geo": {
    "itemStyle": {
      "areaColor": "#eee",
      "borderColor": "#444",
      "borderWidth": 0.5
    },
    "label": {
      "color": "#000"
    },
    "emphasis": {
      "itemStyle": {
        "areaColor": "#06f3aa",
        "borderColor": "#444",
        "borderWidth": 1
      },
      "label": {
        "color": "#002dff"
      }
    }
  },
  "categoryAxis": {
    "axisLine": {
      "show": true,
      "lineStyle": {
        "color": "#424C57"
      }
    },
    "axisTick": {
      "show": true,
      "lineStyle": {
        "color": "#424C57"
      }
    },
    "axisLabel": {
      "show": true,
      "color": "#87929B"
    },
    "splitLine": {
      "show": false,
      "lineStyle": {
        "color": [
          "#dbdee4"
        ]
      }
    },
    "splitArea": {
      "show": false,
      "areaStyle": {
        "color": [
          "rgba(234,237,245,0.5)",
          "rgba(255,255,255,0)"
        ]
      }
    }
  },
  "valueAxis": {
    "axisLine": {
      "show": false,
      "lineStyle": {
        "color": "#54555a"
      }
    },
    "axisTick": {
      "show": false,
      "lineStyle": {
        "color": "#54555a"
      }
    },
    "axisLabel": {
      "show": true,
      "color": "#87929B"
    },
    "splitLine": {
      "show": true,
      "lineStyle": {
        "color": [
          "#424c57"
        ]
      }
    },
    "splitArea": {
      "show": false,
      "areaStyle": {
        "color": [
          "rgba(234,237,245,0.5)",
          "rgba(255,255,255,0)"
        ]
      }
    }
  },
  "logAxis": {
    "axisLine": {
      "show": false,
      "lineStyle": {
        "color": "#54555a"
      }
    },
    "axisTick": {
      "show": false,
      "lineStyle": {
        "color": "#54555a"
      }
    },
    "axisLabel": {
      "show": true,
      "color": "#87929B"
    },
    "splitLine": {
      "show": true,
      "lineStyle": {
        "color": [
          "#424c57"
        ]
      }
    },
    "splitArea": {
      "show": false,
      "areaStyle": {
        "color": [
          "rgba(234,237,245,0.5)",
          "rgba(255,255,255,0)"
        ]
      }
    }
  },
  "timeAxis": {
    "axisLine": {
      "show": true,
      "lineStyle": {
        "color": "#424c57"
      }
    },
    "axisTick": {
      "show": true,
      "lineStyle": {
        "color": "#424c57"
      }
    },
    "axisLabel": {
      "show": true,
      "color": "#87929B"
    },
    "splitLine": {
      "show": false,
      "lineStyle": {
        "color": [
          "#dbdee4"
        ]
      }
    },
    "splitArea": {
      "show": false,
      "areaStyle": {
        "color": [
          "rgba(234,237,245,0.5)",
          "rgba(255,255,255,0)"
        ]
      }
    }
  },
  "toolbox": {
    "iconStyle": {
      "borderColor": "#999"
    },
    "emphasis": {
      "iconStyle": {
        "borderColor": "#666"
      }
    }
  },
  "legend": {
    "textStyle": {
      "color": "#87929B"
    },
    "left": "center",
    "right": "auto",
    "top": "auto",
    "bottom": 10
  },
  "tooltip": {
    "axisPointer": {
      "lineStyle": {
        "color": "#d9d9d9",
        "width": 1
      },
      "crossStyle": {
        "color": "#d9d9d9",
        "width": 1
      }
    }
  },
  "timeline": {
    "lineStyle": {
      "color": "#424C57",
      "width": 2
    },
    "itemStyle": {
      "color": "#06F3AA",
      "borderWidth": ""
    },
    "controlStyle": {
      "color": "#87929b",
      "borderColor": "#87929B",
      "borderWidth": 0
    },
    "checkpointStyle": {
      "color": "#fff",
      "borderColor": "#06F3AA"
    },
    "label": {
      "color": "#87929B"
    },
    "emphasis": {
      "itemStyle": {
        "color": "#FFF"
      },
      "controlStyle": {
        "color": "#87929b",
        "borderColor": "#87929B",
        "borderWidth": 0
      },
      "label": {
        "color": "#87929B"
      }
    }
  },
  "visualMap": {
    "color": [
      "#fa4747",
      "#fc9c9c",
      "#fedcdc"
    ]
  },
  "markPoint": {
    "label": {
      "color": "#252b36"
    },
    "emphasis": {
      "label": {
        "color": "#252b36"
      }
    }
  },
  "grid": {
    "left": "15%",
    "right": "10%",
    "top": 65,
    "bottom": 80
  }
}
